'use client';

import { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import { useCollections } from '@/views/CollectionsView/useCollections';

import type { CollectionList } from '@/api/types/collections.types';
import type { InfiniteLoaderData } from '@/api/types/common.types';

import { CollectionCard } from '@/components/CollectionCard';
import { CollectionCardSkelton } from '@/components/CollectionCard/CollectionCardSkelton';
import { LoaderButton } from '@/components/LoaderButton';
import { ResultNotFound } from '@/components/ResultNotFound';

import styles from '@/views/CollectionsView/CollectionsView.module.scss';

// ----------------------------------------------------------------

export const CollectionsList = () => {
  const { ref, data, handleButtonClick, hasNextPage, isLoading } = useCollections();

  if (!data) {
    return (
      <Container className={styles.container}>
        <Row as="ul" xs={1} sm={2} md={2} lg={3} xl={3} className="mb-3">
          {Array(12)
            .fill(null)
            .map((_, index) => (
              <Col key={index} as="li" className="mb-4">
                <CollectionCardSkelton />
              </Col>
            ))}
        </Row>
      </Container>
    );
  }

  return (
    <Fragment>
      {data?.list && data?.list.length > 0 && (
        <Fragment>
          <Row as="ul" xs={1} sm={2} md={2} lg={3} xl={3} className="mb-3">
            {data?.list.map(collection => (
              <Col key={collection.id} as="li" className="mb-4">
                <CollectionCard href={`/collection/11/${collection.id}`} collection={collection} />
              </Col>
            ))}
          </Row>
          <div className="mb-5">
            {hasNextPage && (
              <LoaderButton ref={ref} isLoading={isLoading} onClick={handleButtonClick} />
            )}
          </div>
        </Fragment>
      )}
      {data?.list.length === 0 && <ResultNotFound />}
    </Fragment>
  );
};
